module.exports = __webpack_public_path__ + "img/logo.0c607905.jpg";